// extracted by mini-css-extract-plugin
module.exports = {"border":"RoomOptionsSidebarItem_border__2ysGL"};